async function fetchOptions(handle) {
    if (!handle) {
        return;
    }

    const response = await fetch(`/products/${handle}?view=search-model`);
    const htmlText = await response.text();

    const doc = new DOMParser().parseFromString(htmlText, 'text/html');
    document.querySelector('.custom-options').replaceWith(doc.querySelector('.custom-options'));
    const form = document.querySelector('.product-form');
    const button = form.querySelector("button[type='submit']");
    button.textContent = 'בחר צבע וגודל';
    button.disabled = true;
    const btn = document.querySelector(".add-insole");
    if (!btn) return;
    btn.style.display = 'none';
    btn.textContent = 'אין בידוד זמין לגודל זה';
    btn.disabled = true;
}

class SelectContainer extends HTMLElement {
    constructor(){
        super();
        this.addEventListener('change', this.updateButtonText.bind(this));
    }

    updateButtonText = () => {
        this.color = document.querySelector('input[name="properties[Color]"]:checked') ? this.querySelector('input[name="properties[Color]"]:checked').value : null;
        this.size = document.querySelector('input[name="properties[Size]"]:checked') ? this.querySelector('input[name="properties[Size]"]:checked').value : null;
        const form = document.querySelector('.product-form');
        const button = form.querySelector("button[type='submit']");
        if(this.querySelector('input[name="properties[Model]"]:checked')){
            if(this.color && this.size){

            }else {
                button.textContent = 'בחר צבע וגודל';
                button.disabled = true;
            }
        }
        if(document.getElementById('agree-condition').checked == false){
            button.disabled = true;
        }

        if(document.querySelector('input[name="properties[Model]"]:checked') && document.querySelector('input[name="properties[Color]"]:checked') && document.querySelector('input[name="properties[Size]"]:checked')){
            document.querySelector('.check-condition').style.display = '';
        }else {
            document.querySelector('.check-condition').style.display = 'none';
        }

        updateVariantChange();
    }
}

document.getElementById('agree-condition').addEventListener('change', function(){
    const form = document.querySelector('.product-form');
    const button = form.querySelector("button[type='submit']");
    if(document.querySelector('input[name="properties[Model]"]:checked') && document.querySelector('input[name="properties[Color]"]:checked') && document.querySelector('input[name="properties[Size]"]:checked')){
        if(this.checked){
            button.disabled = false;
        }
    }else {
        button.disabled = true;
        const optionValue = document.querySelector('.p-container .input-container input:checked').nextElementSibling.textContent.trim();
        if(optionValue == 'החזרה'){
            button.disabled = false;
        }
    }
});

customElements.define('select-container', SelectContainer)

class OptionChange extends HTMLElement {
    connectedCallback() {
        this.color = this.querySelector('input[name="properties[Color]"]:checked') ? this.querySelector('input[name="properties[Color]"]:checked').value : null;
        this.size = this.querySelector('input[name="properties[Size]"]:checked') ? this.querySelector('input[name="properties[Size]"]:checked').value : null;

        this.variantData = JSON.parse(
            this.querySelector('script[type="application/json"]').textContent
        );

        this.addEventListener('change', this.onChange.bind(this));
    }

    onChange(event) {
        this.color = this.querySelector('input[name="properties[Color]"]:checked') ? this.querySelector('input[name="properties[Color]"]:checked').value : null;
        this.size = this.querySelector('input[name="properties[Size]"]:checked') ? this.querySelector('input[name="properties[Size]"]:checked').value : null;
        
        document.querySelectorAll('input[name="properties[Size]"]').forEach(input => {
            input.disabled = false;
        });

        if(this.color){
            this.variantData.find(variant =>{
                if(variant.option1 == this.color){
                    if(variant.available == false){
                        document.querySelector(`input[value="${variant.option2}"]`).disabled = true;
                    }
                }
            });
        }

        if(this.color && this.size){
            this.variantData.find(variant =>{
                if(variant.option1 == this.color && variant.option2 == this.size){
                    this.updateButton(variant);        
                }
            });
        }else {
            this.updateButton(false);
        }

        //console.log(this.color, this.size);
    }

    

    findVariant(selectedOptions) {
        if (selectedOptions.includes('')) return null;

        return this.variantData.find(variant =>
            variant.options.every((opt, index) => opt === selectedOptions[index])
        );
    }

    updateButton(variant) {
        const form = document.querySelector('.product-form');
        const button = form.querySelector("button[type='submit']");
        const idInput = form.querySelector('input[name="id"]');

        console.log(variant);
        const mainVariant = variant;

        // Incomplete selection
        if (!variant) {
            button.textContent = 'בחר צבע וגודל';
            button.disabled = true;
            return;
        }

        // Variant exists but sold out
        if (!variant.available) {
            idInput.value = variant.id;
            button.textContent = 'הַכַּרטִיסִים אָזלוּ';
            button.disabled = true;
            return;
        }

        // Variant available
        //idInput.value = variant.id;
        button.textContent = 'הוסף לסל';
        button.disabled = false;

        const btn = document.querySelector(".add-insole");
        if (!btn) return;

        window.matchSizeVariant = false;
        window.insoleVariants.forEach(variant => {
            const firstText = String(mainVariant.option2).split(' ')[2];
            console.log(firstText, variant.option1, String(mainVariant.option2).split(' ')[2]);
            console.log(String(variant.option1).includes(firstText), variant.available);
            if(String(firstText).includes('/')){
                if(String(firstText).includes(variant.option2) && variant.available){
                    window.matchSizeVariant = variant;
                }
            }else {
                if(String(variant.option2).includes(firstText) && variant.available){
                    window.matchSizeVariant = variant;
                }        
            }
        })

        if(window.matchSizeVariant != false){
            btn.textContent = `הוסיפו מדרסים מקוריים של פוגו + ${window.InsoleProPrice}`;
            btn.dataset.variantId = window.matchSizeVariant.id;
            btn.disabled = false;
            btn.style.display = '';
        }else {
            btn.style.display = 'none';
            btn.textContent = 'אין בידוד זמין לגודל זה';
            btn.disabled = true;
            return;
        }
    }
}

customElements.define('option-change', OptionChange);

setTimeout(() => {
    //console.log(document.querySelector('.product-form'));
    document.querySelector('.product-form').querySelector("button[type='submit']").disabled = true;
    //document.querySelector('.product-form').querySelector("button[type='submit']").textContent = 'בחר דגם';
}, 1000);

if(!customElements.get('select-container')){
    class SelectContainer extends HTMLElement {
        constructor(){
            super();
            this.addEventListener('change', this.toggleInsole.bind(this));
        }

        toggleInsole = (event) => {
            console.log(event);
            if(document.getElementById('select-option-size')){
                if(document.getElementById('select-option-size').value != ''){
                    document.querySelector('.add-insole').style.display = '';
                }else {
                    document.querySelector('.add-insole').style.display = 'none';
                }
            }else {
                document.querySelector('.add-insole').style.display = 'none';
            }

            this.size = document.querySelector('input[name="properties[Size]"]:checked') ? this.querySelector('input[name="properties[Size]"]:checked').value : null;
            
            if(event.target.id == 'select-option-size'){
                document.querySelector('.add-insole').textContent = `הוסיפו מדרסים מקוריים של פוגו + ${window.InsoleProPrice}`;
                document.querySelector('.add-insole').disabled = false;
                const btn = document.querySelector(".add-insole");
                if (!btn) return;

                // window.matchSizeVariant = false;
                // if(document.getElementById('select-option-size') && document.getElementById('select-option-size').value != ''){
                //     window.insoleVariants.forEach(variant => {
                //         const firstText = String(this.size).split(' ')[0];
                //         console.log(firstText, variant.option1);
                //         console.log(String(variant.option1).includes(firstText), variant.available);
                //         if(String(variant.option1).includes(firstText) && variant.available){
                //             window.matchSizeVariant = variant;
                //         }        
                //     })
                // }

                // if(window.matchSizeVariant != false){
                //     btn.textContent = `Add Original Fugu Insole + ${window.InsoleProPrice}`;
                //     btn.dataset.variantId = window.matchSizeVariant.id;
                //     btn.disabled = false;
                //     btn.style.display = '';
                // }else {
                //     btn.style.display = 'none';
                //     btn.textContent = 'No isole Available for this size';
                //     btn.disabled = true;
                //     return;
                // }
            }
        }
    }

    customElements.define('select-container', SelectContainer);
}


document.addEventListener("DOMContentLoaded", function () {
  const btn = document.querySelector(".add-insole");
  if (!btn) return;


  btn.addEventListener("click", async function () {
    const itemKey = btn.getAttribute("data-item-key");

    const variantId = btn.dataset.variantId;

    // ADD ITEM
    if (!itemKey) {
      btn.disabled = true;
      btn.textContent = "מוסיפים מדרסים...";

      try {
        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        });

        if (!res.ok) throw new Error("Add failed");

        const cart = await fetch("/cart.js").then(r => r.json());
        const addedItem = cart.items.find(i => i.variant_id == variantId);

        if (addedItem) {
          btn.setAttribute("data-item-key", addedItem.key);
          btn.innerHTML = 'נוסף מדרס מקורי של פוגו ✔ (הסר)';
          document.querySelector('.product-price .price').textContent = window.TotalSubPrice;
        }

      } catch (e) {
        btn.textContent =` + ${window.InsoleProPrice}`;
      } finally {
        btn.disabled = false;
      }

      return;
    }

    // REMOVE ITEM
    btn.disabled = true;
    btn.textContent = "הסרת מדרסים מקוריים של פוגו...";

    try {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: itemKey,
          quantity: 0
        })
      });

      btn.removeAttribute("data-item-key");
      btn.textContent = `הוסיפו מדרסים מקוריים של פוגו + ${window.InsoleProPrice}`;
      document.querySelector('.product-price .price').textContent = window.MainProPrice;

    } catch (e) {
      btn.innerHTML = 'נוסף מדרס מקורי של פוגו ✔ (הסר)';
    } finally {
      btn.disabled = false;
    }
  });
});

function updateVariantChange(){
    const optionValue = document.querySelector('.p-container .input-container input:checked').nextElementSibling.textContent.trim();
    document.querySelectorAll(`.description-area [data-variant-id]`).forEach(el => {
        el.style.display = 'none';
    });

    console.log(optionValue)
    
    document.querySelector(`.description-area [data-variant-title="${optionValue}"]`)? document.querySelector(`.description-area [data-variant-title="${optionValue}"]`).style.display = '': "";
    if(optionValue == 'החזרה'){
        if(document.querySelector('select-model')){
            document.querySelector('select-model').style.display = 'none';
        }
        if(document.querySelector('.custom-options')){
            document.querySelector('.custom-options').style.display = 'none';
        }
        document.querySelector('.check-condition').style.display = '';
    }else {
        if(document.querySelector('select-model')){
            document.querySelector('select-model').style.display = '';
        }
        if(document.querySelector('.custom-options')){
            document.querySelector('.custom-options').style.display = '';
        }
    }
}

updateVariantChange();

document.querySelectorAll('.p-container .input-container input').forEach(input => {
    input.addEventListener('change', function(){
        console.log('kdjhdsh jhsdjh', this.checked, this.value);
        const valueText = this.getAttribute('data-condition-text');
        document.querySelector('label[for="agree-condition"]').innerText = valueText;
        updateVariantChange();
    });
});